import React from 'react'
import Modal from 'react-bootstrap/Modal'
import {Button} from 'react-bootstrap'

interface ConfirmDialogProps {
  show: boolean
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  variant?: 'danger' | 'warning' | 'primary'
  onConfirm: () => void
  onClose: () => void
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title = 'ยืนยันการดำเนินการ',
  message,
  confirmText = 'ยืนยัน',
  cancelText = 'ยกเลิก',
  variant = 'danger',
  onConfirm,
  onClose,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className={'py-3'}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={'py-5'}>
        <div className='text-center'>
          <i className='bi bi-exclamation-triangle-fill text-warning fs-2x mb-5' style={{fontSize: '3rem'}}></i>
          <p className='fs-5 mb-0'>{message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className={'border-0 justify-content-center pt-0'}>
        <Button variant='secondary' onClick={onClose}>
          {cancelText}
        </Button>
        <Button variant={variant} onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmDialog
